// @ts-nocheck
class AuthUtils {
  static async clearAuth() {
    const lang = localStorage.getItem('i18nextLng') || 'en';
    localStorage.clear();
    localStorage.setItem('i18nextLng', lang);
  }
}

export default AuthUtils;